<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { api } from '../api/client';
const email = ref(''); const password = ref(''); const error = ref(''); const loading = ref(false); const router = useRouter();
function takeReturnPath() {
  // Только внутренние пути админки — без внешних адресов.
  let path = '/';
  try { const saved = sessionStorage.getItem('forma.returnTo'); sessionStorage.removeItem('forma.returnTo'); if (saved && saved.startsWith('/') && !saved.startsWith('//')) path = saved; } catch { /* хранилище недоступно */ }
  return path;
}
async function submit() { loading.value = true; error.value = ''; try { await api.login(email.value, password.value); router.push(takeReturnPath()); } catch (e: any) { error.value = e.message; } finally { loading.value = false; } }
</script>
<template>
  <main class="auth-page"><section class="auth-card">
    <div class="auth-brand"><img class="brand-logo" src="/brand/bgpu-logo.png" alt="БГПУ" width="127" height="34"/><span class="brand-caption">Формы</span></div>
    <div><h1>Вход в админку</h1><p class="muted">Управляйте формами и ответами</p></div>
    <form class="stack" @submit.prevent="submit">
      <label class="input-label">Email<input v-model="email" class="control" type="email" autocomplete="email" required/></label>
      <label class="input-label">Пароль<input v-model="password" class="control" type="password" autocomplete="current-password" required/></label>
      <p v-if="error" class="alert error">{{ error }}</p><button class="btn btn-primary btn-wide" :disabled="loading">{{ loading ? 'Входим…' : 'Войти' }}</button>
    </form>
  </section></main>
</template>
